// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateEvent/ConfirmDeleteEventModal/ConfirmDeleteEventModal.css
// module id = 1675
// module chunks = 0